<template>
    <base-form :formType="'askQuestion'" ref="baseForm">
        <template v-slot:slotData="res">

            <!-- 咨询问题分类 -->
            <van-field readonly clickable name="category" v-model="res.formData.category" label="职务" placeholder="请选择咨询分类"
                :rules="[{ required: true, message: '请选择问题分类' }]" @click="showQues = true">
                <template #label>
                    咨询问题分类<span class="required-star">*</span>
                </template>
            </van-field>
            <van-popup v-model="showQues" position="bottom">
                <van-picker show-toolbar :columns="questionCategories" @confirm="setQuesValue($event, 'category')"
                    @cancel="showQues = false" />
            </van-popup>

            <!-- 问题详情 -->
            <van-field v-model="res.formData.details" name="details" label="问题详情" placeholder="请输入问题详情"
                :rules="[{ required: true, message: '请输入问题详情' }]">
                <template #label>
                    问题详情<span class="required-star">*</span>
                </template>
            </van-field>

            <!-- 图片上传 -->
            <div class="uploadBox">
                <div class="uploadTxt"> 上传图片<span class="required-star">*</span></div>
                <van-uploader
                    v-model="images"
                    max-count="6"
                    :after-read="onAfterRead"
                    :before-delete="onBeforeDelete"
                    :rules="[{ required: true }]"
                >
                    <template #default>
                        <div class="custom-uploader">
                            <span class="plus-icon">+</span>
                        </div>
                    </template>

                   
                </van-uploader>
            </div>

        </template>
    </base-form>
</template>

<script>
import BaseForm from "./BaseForm.vue";
import ossUpload from "@/utils/ossUpload";

export default {
    components: { BaseForm },
    data() {
        return {
            images:[],
            pathUrl: [],
            showQues: false,
            questionCategories: ["咨询产品或解决方案", "寻求售后服务", "提交质量投诉","其他"],
        };
    },
    mounted(){
        this.initShare();
        this.$dataStatistics({
            page_title: `我要提问`,
        },'访问');
    },
    methods: {
        setQuesValue(val, name) {
            this.$refs.baseForm.setValue(val, name);
            this.showQues = false;
        },
        onAfterRead(file) {
            this.$http
                .get("/api/platform/oss-upload-url")
                .then(response => {
                    const ossInfo = response.data;
                    return ossUpload(file.file, ossInfo, file.file.name, (progressEvent) => {
                        file.status = 'uploading';
                        file.message = Math.round(progressEvent.percent) + '%';
                    });
                })
                .then(res => {
                    file.status = 'done';
                    file.url = res.path;
                    console.log('file.url ---:', file.url);
                    this.pathUrl.push(file.url);
                    this.$refs.baseForm.setValue(this.pathUrl, 'path');
                })
                .catch(error => {
                    file.status = 'failed';
                    this.$message.error(error.message || "上传失败");
                });
        },
        onBeforeDelete(item, detail) {
            const index = this.pathUrl.indexOf(item.url);
            if (index !== -1) {
                this.pathUrl.splice(index, 1);
                this.$refs.baseForm.setValue(this.pathUrl, 'path');
            }
            return true; // Return true to allow the deletion
        }
    }
};
</script>

<style lang="less" scoped>
::v-deep .van-uploader__preview-delete{
    width: 18px;
height: 18px;
background: #9F9F9F;
border-radius: 50%;
right: -9px;
top: -9px;
display: flex;
align-items: center;
justify-content: center;
}
::v-deep .van-uploader__preview-delete-icon{
    position: static;
    transform: scale(1);
    font-size: 10px;
}
::v-deep .van-uploader__preview-image{
    border-radius: 1.067vw;
}
.uploadBox {
    padding: 0 16px;
    font-size: 14px;
    color: #333333;

    .uploadTxt {
        margin-top: 12px;
        margin-bottom: 16px;
    }

    .custom-uploader {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 80px;
        background: #F3F3F3;
        border-radius: 4px;
        cursor: pointer;
    }

    .plus-icon {
        font-size: 34px;
        color: #9F9F9F;
    }
}
</style>